import { createAction } from 'redux-act'

export const openConfirm = createAction()
export const closeConfirm = createAction()